import { Component } from '@angular/core';
import { HttpModule } from '@angular/http';
import {  Http, Headers, RequestOptions } from '@angular/http';
import { FileService } from './file.service';


@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  title = 'app';
  fonts = [];
  toggletext = "Unicode to ASCII"
  disable = 0
  fileToUpload: File = null;
  font_data = 'Select A Font'
  first_text = "Only .txt,.pdf,.odt,.doc,.docx. Max. 2MB"


convert(){
	var textbox  = <HTMLInputElement>document.getElementById("comment")
        var type_conv = ''

	if (this.toggletext == "ASCII to Unicode"){
		type_conv = 'send_a2u';
	} else if (this.toggletext == "Unicode to ASCII"){
		type_conv = 'send_u2a';
	}
 	
	if ((this.font_data !=  'Select A Font') && ( this.fileToUpload != null)){
		var box1  = <HTMLInputElement>document.getElementById("spacing")
		var box2  = <HTMLInputElement>document.getElementById("loading")
		box1.style.display = 'none'
		box2.style.display = 'inline'
		this.fileService.postFile(this.fileToUpload, this.font_data, type_conv).subscribe(data => {
	      			var textbox  = <HTMLInputElement>document.getElementById("response");
				textbox.style.fontFamily = "Brig"+ data.font+ ",Charcoal,sans-serif"; {}
	      			textbox.value = data.response;
				box1.style.display = 'inline-block'
				box2.style.display = 'none'
	      }, error => {
		console.log(error);
	      });
	}
	else if ((this.font_data !=  'Select A Font') && (textbox.value != '')){
		    var headers = new Headers();
		    headers.append("Accept", 'application/json');
		    headers.append('Content-Type', 'application/json' );
		    let options = new RequestOptions({ headers: headers });
		    const endpoint = 'http://14.139.174.73:81/' + type_conv;
		    var data_send = JSON.stringify({text: textbox.value,font:this.font_data,type:this.toggletext});
		    var box1  = <HTMLInputElement>document.getElementById("spacing")
		    var box2  = <HTMLInputElement>document.getElementById("loading")
		    box1.style.display = 'none'
		    box2.style.display = 'inline'
		    this.http.post(endpoint, data_send, options) .map(res =>  res.json()).subscribe(data => {
				var textbox  = <HTMLInputElement>document.getElementById("response");
				textbox.style.fontFamily = "Brig"+ data.font+ ",Charcoal,sans-serif"; {}
	      			textbox.value = data.response;
				box1.style.display = 'inline-block'
				box2.style.display = 'none'

	      }, error => {
		console.log(error);
	      });
	} else {
		alert("Check whether you have chosen the Font.");
	}
}


clear(){
	var textbox1  = <HTMLInputElement>document.getElementById("usr")
	var textbox2  = <HTMLInputElement>document.getElementById("response")
	var textbox3 = <HTMLInputElement>document.getElementById("comment")
	textbox1.value = ''
	textbox2.value = ''
	textbox3.value = ''
	this.disable = 0
}

uploadf(files: FileList){
	this.fileToUpload = files.item(0);
	var file = <HTMLInputElement>document.getElementById("upin");
	var textbox1  = <HTMLInputElement>document.getElementById("usr")
	textbox1.value = file.files[0].name
	this.disable = 1

}

upload(){
	var file = document.getElementById("upin");
	file.click()
}

toggleclick(item){
	if (item == "Unicode to ASCII"){
		this.toggletext = "ASCII to Unicode";
	} else if (item == "ASCII to Unicode"){
		this.toggletext = "Unicode to ASCII";
	}
}
constructor(public http: Http, private fileService:FileService) {
      this.http.get('../assets/data.txt').subscribe(data => {
		var tex  = data.text();
		this.fonts = tex.split(",").sort();
   })
  }
}




// WEBPACK FOOTER //
// ./src/app/app.component.ts